module.exports = __webpack_public_path__ + "img/108.a9b4b542.jpg";